<template>
  <v-app>
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/loadtunay.gif"
      />
    </v-overlay>
    <v-app-bar
        app
        clipped-left
        color="#393E46"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <router-link :to="{ name: 'homepage'}">
          <v-img
              alt="Tunay Logo"
              class="shrink mt-1 "
              contain
              min-width="100"
              src="@/assets/tunaywhitelogo.png"
              width="100"
          />
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <loginbox/>
    </v-app-bar>
  </v-app>
</template>
<script>
import {mapGetters} from "vuex";
import Loginbox from "@/components/modals/loginbox";


export default {
  name: 'leftsinmenupromotor',
  components: {Loginbox},
  data: () => ({
    drawer: null,
    negocios: [],
    overlay:false
  }),
  mounted() {
  this.dameNegocios();
  },
  methods:{
    dameNegocios(){
      this.negocios = this.pnegocios
    }
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      usuario: "usuario",
      pnegocios: "pnegocios"
    })
  }
}
</script>